import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Downloading Icon
 *
 * @file Downloading.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Downloading = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 11L12 9.25L13 9.25C13.6904 9.25 14.25 8.69036
            14.25 8L14.25 4C14.25 3.30964 13.6904 2.75 13 2.75L5
            2.75C4.30965 2.75 3.75 3.30964 3.75 4L3.75 8C3.75
            8.69036 4.30964 9.25 5 9.25L6 9.25L6 11L5 11C3.34315
            11 2 9.65685 2 8L2 4C2 2.34314 3.34315 0.999999 5 0.999999L13
            1C14.6569 1 16 2.34315 16 4L16 8C16 9.65685 14.6569 11
            13 11L12 11ZM8.32562 17.7185L5.27934 14.6408C4.90689
            14.2654 4.90689 13.6569 5.27934 13.2815C5.65179 12.9062
            6.25565 12.9062 6.6281 13.2815L8 14.6718L8 6C8 5.44771
            8.44772 5 9 5C9.55229 5 10 5.44771 10 6L10 14.6718L11.3719
            13.2815C11.7444 12.9062 12.3482 12.9062 12.7207 13.2815C13.0931
            13.6569 13.0931 14.2654 12.7207 14.6408L9.67438 17.7185C9.30193
            18.0938 8.69807 18.0938 8.32562 17.7185Z"
        fill="currentcolor"
      />
    </g>
  </SvgIcon>
);

export default Downloading;
